import { render } from "./FloorDetailMaterials.vue?vue&type=template&id=2eefa25b&scoped=true"
import script from "./FloorDetailMaterials.vue?vue&type=script&lang=js"
export * from "./FloorDetailMaterials.vue?vue&type=script&lang=js"

import "./FloorDetailMaterials.vue?vue&type=style&index=0&id=2eefa25b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eefa25b"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QTr,QTd,QSeparator,QList,QExpansionItem});
